import { LoadingButton } from '@mui/lab'
import { Box, Breakpoint, Stack, TextField, Typography } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import { useAppSelector } from 'app/hooks'
import React from 'react'
import { useParams } from 'react-router-dom'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: JSX.Element
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

interface Props {
  open: boolean
  title?: string
  primaryButton?: boolean
  primaryButtonText?: string
  loading?: boolean
  maxWidth?: Breakpoint
  primaryButtonColor?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
  handleClose: () => void
  handleSubmit?: () => void
  children: string | JSX.Element | JSX.Element[]
  eventId: number | null
  cpId: number | null
}

export default function DialogQuiz({
  open,
  loading,
  title = '問題',
  maxWidth = 'sm',
  primaryButton = true,
  primaryButtonText = 'OK',
  children,
  handleClose,
  handleSubmit,
  eventId,
  cpId,
}: Props) {
  // const { id, pid } = useParams<{ id: string; pid: string }>()
  const event = useAppSelector((s) =>
    s.Event.list.find((f) => f.id === Number(eventId))
  )
  const point = event?.checkpoints.find((f) => f.id === Number(cpId))
  const template = point?.template.qImage
  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={maxWidth}
        onClose={(_e, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
      >
        <DialogTitle sx={{ fontWeight: 'bold' }}>{title}</DialogTitle>
        <DialogContent>
          <Stack spacing={1}>{children}</Stack>
          <Box
            sx={{
              width: '100%',
            }}
          >
            <Typography>
              下の画像にある文字を入力せよ{point?.quizText}
            </Typography>
          </Box>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={'100%'}
          >
            <img
              src={template}
              alt={title}
              loading="lazy"
              crossOrigin="anonymous"
              style={{
                maxWidth: '100%',
                maxHeight: '100%',
                objectFit: 'contain',
              }}
            />
          </Box>
          <TextField
            autoFocus
            required
            margin="dense"
            label="解答を入力"
            fullWidth
            variant="standard"
            // {...register('name')}
            // error={'name' in errors}
            // helperText={errors.name?.message}
          />
        </DialogContent>
        <DialogActions>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={'100%'}
          >
            <Stack
              width="100%"
              direction="row"
              justifyContent="space-around"
              alignItems="center"
              mb={2}
            >
              {primaryButton && (
                <LoadingButton
                  loading={loading}
                  color="primary"
                  variant="contained"
                  size="small"
                  type="submit"
                  fullWidth
                  sx={{
                    px: 4,
                  }}
                >
                  {primaryButtonText}
                </LoadingButton>
              )}
            </Stack>
          </Box>
        </DialogActions>
        <DialogActions>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={'100%'}
          >
            <Stack
              width="100%"
              direction="row"
              justifyContent="space-around"
              alignItems="center"
              mb={2}
            >
              <LoadingButton
                loading={loading}
                variant="contained"
                color="warning"
                size="small"
                fullWidth
                sx={{
                  px: 4,
                }}
                onClick={() => handleClose()}
              >
                ヒントを見る
              </LoadingButton>
            </Stack>
          </Box>
        </DialogActions>
        <DialogActions>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            width={'100%'}
          >
            <Stack
              width="100%"
              direction="row"
              justifyContent="space-around"
              alignItems="center"
              mb={2}
            >
              <LoadingButton
                loading={loading}
                variant="outlined"
                color="primary"
                size="small"
                fullWidth
                sx={{
                  px: 4,
                }}
                onClick={() => handleClose()}
              >
                マップに戻る
              </LoadingButton>
            </Stack>
          </Box>
        </DialogActions>
      </Dialog>
    </>
  )
}
